export default "__VITE_ASSET__CFd8KKAL__"